import React from "react";
import MainRegisteredCourses from "../../MainContent/MainRegisteredCourses";

const Registered = () => {
  return <MainRegisteredCourses />;
};

export default Registered;
